import {stringify} from 'qs'
import request from 'utils/request'
import {format} from 'utils'
import api from 'message-control/common/api/sensitive-words'

export async function list(params) {
    return request(`${api.list.url}?${stringify(params)}`)
}

export async function create(params = {}) {
    return request(format(api.create.url), {
        method: api.create.type,
        body: params.body,
    })
}

export async function remove(params = {}) {
    return request(format(api.remove.url, {id: params.id}), {
        method: api.remove.type,
        body: params.body,
    })
}
